export default __webpack_public_path__ + "static/media/img19.dd625437.jpg";